import React from "react";
import PageShell from "@/components/PageShell";
import Contact from "@/components/Contact";

export default function ContactPage() {
    return (
        <PageShell>
            <Contact />
        </PageShell>
    );
}
